import {FormAbstract} from "./FormAbstract";

export class FormHtml extends FormAbstract implements FormAbstract {
    readonly name = '' as TFormPartName;

    isValid(): boolean {
        return true;
    }

    getHtml(): string {
        return this.field.html ?? '';
    }

    getSubmitData(): null {
        return null;
    }

    getSubmitDataButton(): null {
        return null;
    }

    getFormPartParameters(): any {
        return null;
    }

}